<div class="prosition-relative">
	<div class="loading-data" *ngIf="isLoadingResults">
		<mat-spinner [diameter]="50"></mat-spinner>
	</div>
	<app-calendar-wrapper
		*ngIf="customOptions"
		[customOptions]="customOptions"
		[required]="required"
		[disabled]="disabled"
		[viewOnly]="viewOnly"
		[data]="data"
		[formioComponent]="formioComponent"
		[value]="events$ | async"
		(valueChange)="calendarValueChanged($event)"
	></app-calendar-wrapper>
</div>
